import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import heroBg from "@/assets/hero-hospital-corridor.png?format=webp&w=1920&quality=72";

const ease = [0.22, 1, 0.36, 1] as const;

const ClosingCTA = () => {
  return (
    <section className="bg-seabed">
      <div className="relative overflow-hidden bg-seabed text-seabed-foreground min-h-[420px] md:min-h-[480px]">
        <img
          src={heroBg}
          alt=""
          aria-hidden
          loading="lazy"
          decoding="async"
          className="absolute inset-0 h-full w-full object-cover object-center pointer-events-none select-none"
        />

        <div
          className="absolute inset-0 pointer-events-none"
          aria-hidden
          style={{
            background:
              "linear-gradient(180deg, hsl(var(--seabed) / 0.88) 0%, hsl(var(--seabed) / 0.78) 45%, hsl(var(--seabed) / 0.94) 100%)",
          }}
        />
        <div className="hero-overlay-glow" aria-hidden />

        <div className="relative z-10 py-20 md:py-28 px-6 text-center">
          <motion.p
            initial={{ opacity: 0, y: 8 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, ease }}
            className="eyebrow text-seabed-foreground/65"
          >
            Get started
          </motion.p>

          <motion.h2
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease, delay: 0.15 }}
            style={{ textWrap: "balance" } as React.CSSProperties}
            className="font-display tracking-tight text-seabed-foreground text-hero max-w-[880px] mx-auto mt-10"
          >
            Start with the foundation. The rest scales from there.
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.9, ease, delay: 0.32 }}
            className="mt-14 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-5"
          >
            <Link to="/contact" data-theme="dark" className="cta-primary group">
              Talk to our team
              <ArrowUpRight className="cta-arrow h-4 w-4" />
            </Link>
            <Link to="/solution" data-theme="dark" className="cta-ghost group">
              Explore the solution
              <span aria-hidden className="cta-arrow">→</span>
            </Link>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default ClosingCTA;
